export enum Weekdays {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7
}

export const WeekdayLabels: Record<Weekdays, string> = {
  [Weekdays.MONDAY]: "Maandag",
  [Weekdays.TUESDAY]: "Dinsdag",
  [Weekdays.WEDNESDAY]: "Woensdag",
  [Weekdays.THURSDAY]: "Donderdag",
  [Weekdays.FRIDAY]: "Vrijdag",
  [Weekdays.SATURDAY]: "Zaterdag",
  [Weekdays.SUNDAY]: "Zondag"
}
